import cxs from 'cxs';

export default cxs({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center'
});